import { IDashboardResponse } from '../../../../model/sdp/base/dashboard-response';
import { IOfficialDiaryPagedResponse } from '../../../../model/sdp/official-daily/response/official-diary-paged-response';
import { ISubmissionPublicationPagedResponse } from '../../../../model/sep/submission-publications/response/submission-publication-paged-response';
import { Pagination } from '../../../../model/pagination';

export type DashboardState = {
  dashboardDetail: IDashboardResponse;
  officialDiaryItems: Pagination<IOfficialDiaryPagedResponse>;
  submissionPublicationItems: Pagination<ISubmissionPublicationPagedResponse>;
  tabIndex: number;
};

export enum ACTION_TYPES {
  setDashboardDetail = 'setDashboardDetail',
  setOfficialDiaryItems = 'setOfficialDiaryItems',
  setSubmissionPublicationItems = 'setSubmissionPublicationItems',
  setTabIndex = 'setTabIndex',
}

export const DashboardReducer = (state: DashboardState, action: any): DashboardState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setDashboardDetail:
      return {
        ...state,
        dashboardDetail: payload,
      };
    case ACTION_TYPES.setOfficialDiaryItems:
      return {
        ...state,
        officialDiaryItems: payload,
      };
    case ACTION_TYPES.setSubmissionPublicationItems:
      return {
        ...state,
        submissionPublicationItems: payload,
      };
    case ACTION_TYPES.setTabIndex:
      return {
        ...state,
        tabIndex: payload,
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
